import { createAsyncThunk } from '@reduxjs/toolkit';

import { createDeviceRedesign } from '../../../service/graphql/machine/createDeviceRedesign';
import { AsyncThunkConfig } from '../../store';

/**
 * Thunk for creating a device in the redesigned non-VIN flow
 *
 * Uses the new/updated mutations where condition and yearOfManufacture are optional.
 */
export const createDeviceRedesignThunk = createAsyncThunk<void, undefined, AsyncThunkConfig>(
  'addMachine/createDeviceRedesign',
  async (_, { getState }) => {
    const {
      launchDarkly,
      addMachine: {
        data: { condition, nonVinData, startDate },
      },
      selectedAccount: { activeAccountId },
    } = getState();

    if (!activeAccountId) {
      throw new Error('No account selected!');
    }

    if (!nonVinData) {
      throw new Error('Not enough data to create device, nonVinData is empty');
    }

    await createDeviceRedesign(launchDarkly.data, activeAccountId, {
      nonVinData,
      ownershipStartDate: startDate,
      condition,
    });
  },
);
